import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  BASE_TEXT_TITLE_SIZE_CLASS_MAP,
  RESPONSIVE_TEXT_TITLE_SIZE_CLASS_MAP,
  TEXT_TITLE_DEFAULTS,
  TTextTitleProps,
} from "@/ui/components/typography/TextTitle/TextTitle.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
  TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP,
  TYPOGRAPHY_WHITESPACES_CLASS_MAP,
} from "@/ui/components/typography/typography.config";

export const TextTitle: FC<TTextTitleProps> = (
  {
    tag: Tag = TEXT_TITLE_DEFAULTS.tag,
    size = TEXT_TITLE_DEFAULTS.size,
    color = TEXT_TITLE_DEFAULTS.color,
    align = TEXT_TITLE_DEFAULTS.align,
    whitespace = TEXT_TITLE_DEFAULTS.whitespace,
    isResponsive = TEXT_TITLE_DEFAULTS.isResponsive,
    children,
    className,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component="TextTitle"
    className={cn(
      "font-sys-display",
      "font-bold",
      "tracking-sys-tight",
      makeBreakpointClassName(align, TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP, "left"),
      TYPOGRAPHY_WHITESPACES_CLASS_MAP[whitespace],
      TYPOGRAPHY_COLORS_CLASS_MAP[color],
      isResponsive ?
        RESPONSIVE_TEXT_TITLE_SIZE_CLASS_MAP[size] :
        BASE_TEXT_TITLE_SIZE_CLASS_MAP[size],
      className,
    )
    }
  >
    { children }
  </Tag>
);

TextTitle.displayName = "TextTitle";
